import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  invoicesDetail: {},
  invoicesCount: null,
  invoicesList: [],
  retentionsDetail: {},
  retentionsCount: null,
  retentionsList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
